import { d as r } from "./descriptors.js";
import { f as t } from "./fails.js";
import { a as e } from "./an-object.js";
import { o } from "./object-create.js";
import { n as a } from "./normalize-string-argument.js";
var n = Error.prototype.toString,
  s = t(function () {
    if (r) {
      var t = o(Object.defineProperty({}, "name", {
        get: function get() {
          return this === t;
        }
      }));
      if ("true" !== n.call(t)) return !0;
    }
    return "2: 1" !== n.call({
      message: 1,
      name: 2
    }) || "Error" !== n.call({});
  }) ? function () {
    var r = e(this),
      t = a(r.name, "Error"),
      o = a(r.message);
    return t ? o ? t + ": " + o : t : o;
  } : n;
export { s as e };